import Typography from "ds/components/Typography";
import TextEllipsis from "ds/components/TextEllipsis";

import { CellComponentProps } from "../../types";

type RolePermissionsListItemActionCellProps = CellComponentProps;

const RolePermissionsListItemActionCell = ({
  permission,
}: RolePermissionsListItemActionCellProps) => {
  return (
    <TextEllipsis tooltip={permission.name} tooltipWidthMode="maxWidthSm">
      {(props) => (
        <Typography {...props} tag="p" variant="p-body3">
          {permission.name}
        </Typography>
      )}
    </TextEllipsis>
  );
};

export default RolePermissionsListItemActionCell;
